<template>
    <div class="construction-page">
        <!--  内容  -->
        <div class="entity-content">
            <div class="entity-item" v-for="category in arrCategoryList" :key="category.id">
                <!--        项目标题        -->
                <div
                    @click="category.isEnd && handleOpen($event, category.key, arrOpenCategoryKey.includes(category.key))"
                    class="entity-head"
                    :id="sAnchorBefore + category.key"
                    :class="{ 'active-entity': arrOpenCategoryKey.includes(category.key), 'active-head-not-end': !category.isEnd }"
                >
                    <img :src="category.icon" class="title-icon" alt=""/>
                    <div class="name">{{ category.name }}</div>
                    <div class="over-tip">
                        <img v-if="category.isEnd" :src="require('@/assets/images/project-detail/const-end.png')" class="tip-icon" alt=""/>
                        <span>{{ category.isEnd ? "已完工" : "未开始" }}</span>
                    </div>
                    <img
                        v-if="category.isEnd"
                        :class="{ 'open-trans': arrOpenCategoryKey.includes(category.key) }"
                        :src="require('@/assets/images/project-detail/select-system.png')"
                        alt=""
                        class="select-icon"
                    />
                </div>
                <!--        项目内容        -->
                <transition name="unwind">
                    <div class="entity-main" v-if="arrOpenCategoryKey.includes(category.key)">
                        <!--        施工员            -->
                        <div v-for="(bul,bIndex) in category.builder" :key="bul.no + bIndex" class="builder-info-content">
                            <div class="builder-info">
                                <img :src="bul.headImage" alt="" class="head-image"/>
                                <div class="info-box">
                                    <p class="name">
                                        <span>{{ bul.name }}</span>
                                        <span>{{ bul.no }}</span>
                                        <span class="tag">{{ bul.job }}</span>
                                    </p>
                                    <p class="start-wrap" v-if="bul.evaValue">
                                        <img
                                            class="start-icon"
                                            v-for="ite in bul.evaValue"
                                            :key="ite"
                                            :src="require('@/assets/images/project-detail/team-satrt-full.png')"
                                            alt=""
                                        />
                                        <img
                                            class="start-icon"
                                            v-for="ite in 5 - bul.evaValue"
                                            :key="ite + 5"
                                            :src="require('@/assets/images/project-detail/team-satrt-empty.png')"
                                            alt=""
                                        />
                                        <span class="score">{{ bul.score }}分</span>
                                    </p>
                                </div>
                            </div>

                            <!--            人员资质信息        -->
                            <div v-if="bul.aptitudeList" class="person-aptitude">
                                <div class="aptitude-item" v-for="(apt,aIndex) in bul.aptitudeList" :key="apt.name + aIndex">
                                    <img :src="apt.icon" alt=""/>
                                    <div>{{ apt.name }}</div>
                                </div>
                            </div>
                        </div>

                        <!--         施工现场标签布置           -->
                        <div class="construction-site-labeling" v-for="(site, labelIndex) in category.siteLabeling" :key=" site.title +labelIndex">
                            <div class="title">{{ site.title }}</div>
                            <div class="switch-wrap">
                                <div class="switch-content">
                                    <div
                                        @click.stop="switchChange({ categoryKey: category.key, labelId: site.labelId, activeTagKey: tag.key })"
                                        class="switch-item"
                                        :class="{ 'switch-item-active': tag.active }"
                                        v-for="tag in site.switchTag"
                                        :key="tag.key"
                                    >
                                        {{ tag.name }}
                                    </div>
                                </div>
                            </div>

                            <!--       施工标准 swiper       site.decimal[activeTagKey(site)].siteStandard[0].img    -->
                            <div v-if="false" class="swiper-content">
                                <!--                                <Swipe :ref="'labelIndex_default' + labelIndex">-->
                                <!--                                    <SwipeItem class="swiper-item" v-for="item in 4" :key="item">-->
                                <img
                                    @click.stop="handleImagePreview(site.decimal[activeTagKey(site)].siteStandard)"
                                    class="image"
                                    v-for="{ img, key } in site.decimal[activeTagKey(site)].siteStandard"
                                    :key="key"
                                    v-lazy="img"
                                    alt=""
                                />
                                <!--                                    </SwipeItem>-->
                                <!--                                </Swipe>-->
                                <div class="tag">施工标准</div>
                                <!--                                <img @click="$refs['labelIndex_default'+labelIndex][0].prev()" :src="require('@/assets/images/project-detail/to-left-icon.png')" alt="" class="to-left-icon to-icon">-->
                                <!--                                <img @click="$refs['labelIndex_default'+labelIndex][0].next()" :src="require('@/assets/images/project-detail/to-right-icon.png')" alt="" class=" to-icon">-->
                            </div>

                            <!--            工地实况 swiper           -->
                            <div v-if="site.decimal[activeTagKey(site)]" class="swiper-content">
                                <Swipe :ref="'labelIndex_live' + labelIndex" :autoplay="3000" indicator-color="white">
                                    <SwipeItem class="swiper-item" v-for="{ img, key } in site.decimal[activeTagKey(site)].siteLive" :key="key">
                                        <img @click.stop="handleImagePreview(site.decimal[activeTagKey(site)].siteLive,key)" class="image" v-lazy="img" alt=""/>
                                    </SwipeItem>
                                </Swipe>
                                <div class="tag live">工地实况</div>
                                <img
                                    v-if="site.decimal[activeTagKey(site)].siteLive.length > 1"
                                    @click="$refs['labelIndex_live' + labelIndex][0].prev()"
                                    :src="require('@/assets/images/project-detail/to-left-icon.png')"
                                    alt=""
                                    class="to-left-icon to-icon"
                                />
                                <img
                                    v-if="site.decimal[activeTagKey(site)].siteLive.length > 1"
                                    @click="$refs['labelIndex_live' + labelIndex][0].next()"
                                    :src="require('@/assets/images/project-detail/to-right-icon.png')"
                                    alt=""
                                    class="to-icon"
                                />
                            </div>

                            <!--        说明段落       -->
                            <div v-if="site.decimal[activeTagKey(site)]" class="tip-content">
                                <ol>
                                    <li v-for="(item, decimalIndex) in site.decimal[activeTagKey(site)].contentList" :key="decimalIndex">
                                        <span class="decimal">{{ decimalIndex + 1 }}</span>
                                        <span>{{ item }}</span>
                                    </li>
                                </ol>
                            </div>
                        </div>

                        <!--         验收员           -->
                        <div v-if="category.supervision && category.supervision.name" class="inspector-info-content">
                            <div class="inspector-info-wrap">
                                <!--  人员信息  -->
                                <div class="inspector-info">
                                    <div class="title-box">
                                        <span>{{ category.supervision.title }}</span>
                                        <span class="time">{{ category.supervision.time }}</span>
                                    </div>
                                    <!--     人员监理        -->
                                    <div class="person-info">
                                        <img :src="category.supervision.headImage" alt="" class="head-image"/>
                                        <div class="info-box">
                                            <p class="name">
                                                <span>{{ category.supervision.name }}</span>
                                                <span>{{ category.supervision.no }}</span>
                                                <span class="tag">{{ category.supervision.job }}</span>
                                            </p>
                                            <p class="start-wrap" v-if="category.supervision.evaValue">
                                                <img
                                                    class="start-icon"
                                                    v-for="ite in category.supervision.evaValue"
                                                    :key="ite"
                                                    :src="require('@/assets/images/project-detail/team-satrt-full.png')"
                                                    alt=""
                                                />
                                                <img
                                                    class="start-icon"
                                                    v-for="ite in 5 - category.supervision.evaValue"
                                                    :key="ite + 5"
                                                    :src="require('@/assets/images/project-detail/team-satrt-empty.png')"
                                                    alt=""
                                                />
                                                <span class="score">{{ category.supervision.score }}分</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <!--      验收列表      -->
                                <div v-if="category.inspectResult.length" class="inspect-list">
                                    <table>
                                        <tr class="inspect-tr-head">
                                            <th v-for="item in arrInspectTable.length + 1" :key="item" :class="'inspect-col-' + item"></th>
                                        </tr>
                                        <tr class="inspect-tr-body" v-for="(inspect, inspectIndex) in category.inspectResult" :key="inspectIndex">
                                            <td v-for="(item, ind) in arrInspectTable" :class="'inspect-col-' + (ind + 1)" :key="item.key">
                                                <span v-if="!item.onlyLabel">{{ inspect[item.key] }}</span>
                                                <span>{{ item.label }}</span>
                                            </td>
                                            <td>
                                                <img class="end-icon" :src="require('@/assets/images/project-detail/select-icon.png')" alt=""/>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <!--        验收状态      -->
                                <div v-if="category.supervision.isOk" class="inspect-status">
                                    <span>{{ "空调安装验收状态" }}</span>
                                    <div class="btn">
                                        <img :src="require('@/assets/images/project-detail/system-status.png')" alt=""/>
                                        <span>{{ "已通过" }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--          查看详细验收内容          -->
                        <div v-if="category.arrInspect" class="inspect-detail-content">
                            <p @click="setArrInspectList(category.arrInspectPopupList)" class="out-title">查看详细验收内容</p>
                        </div>

                        <!--         评论盒子           -->
                        <div v-if="false && category.userEvaluate" class="evaluate-content-ev">
                            <div class="evaluate-wrap">
                                <div class="title-box">
                                    <span class="title">用户评论</span>
                                    <span class="time-text">{{ category.userEvaluate.time }}</span>
                                </div>
                                <!--   评分展示  -->
                                <div class="star-box">
                                    <img
                                        :src="require('@/assets/images/project-detail/star-full.png')"
                                        v-for="item in category.userEvaluate.evaScore"
                                        :key="item"
                                        alt=""
                                    />
                                    <img
                                        :src="require('@/assets/images/project-detail/star-empty.png')"
                                        v-for="item in 5 - category.userEvaluate.evaScore"
                                        :key="item * 5"
                                        alt=""
                                    />
                                    <span>{{ category.userEvaluate.score }}分</span>
                                </div>
                                <!--     评论标签      -->
                                <div class="tag-box">
                                    <div class="tag-item" v-for="tag in category.userEvaluate.evaTags" :key="tag">{{ tag }}</div>
                                </div>
                                <!--    文字评论展示   -->
                                <div class="evaluate-text">
                                    {{ category.userEvaluate.evaContext }}
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>

        <!--           弹窗-验收             -->
        <Popup v-model="bInspectVisible" class="inspect-popup">
            <!-- 关闭按钮 -->
            <img class="clone-icon"  @click="handleChangeVisible()" :src="require('@/assets/images/project-detail/close-icon.png')" alt=""/>
            <div class="inspect-content" v-for="(item, index) in arrInspectPopupList" :key="index">
                <p class="title">
                    <span>{{ item.title }}</span>
                </p>

                <div class="question-item" v-for="(item2,index2) in item.inspectContent" :key="index2">
                    <p class="question-content">
                        <span>{{ index2 + 1 }}、</span>
                        <span>{{ item2.content }}</span>
                    </p>
                    <p v-if="item2.tip" class="tips">*{{ item2.tip }}</p>

                    <div class="select-item" v-if="item2.isOk == 1">
                        <div>
                            <img :src="require('@/assets/images/project-detail/finish-icon.png')" alt=""/>
                            <span>合格</span>
                        </div>
                        <div>
                            <img :src="require('@/assets/images/project-detail/no-icon.png')" alt=""/>
                            <span>不合格</span>
                        </div>
                    </div>
                    <div class="select-item" v-else>
                        <div>
                            <img :src="require('@/assets/images/project-detail/no-icon.png')" alt=""/>
                            <span>合格</span>
                        </div>
                        <div>
                            <img :src="require('@/assets/images/project-detail/error-icon.png')" alt=""/>
                            <span>不合格</span>
                        </div>
                    </div>
                </div>
            </div>
        </Popup>
    </div>
</template>

<script>
import {Swipe, SwipeItem, Popup, ImagePreview} from "vant";
import {mapState} from "vuex";
import {projectDetailMixin} from "@/page/project/detail/mixin";

export default {
    name: "construction",
    components: {
        Swipe,
        SwipeItem,
        Popup,
        ImagePreview,
    },
    mixins: [projectDetailMixin],
    data() {
        return {
            // 验收表格
            arrInspectTable: [
                {
                    label: "验收点",
                    key: "point",
                },
                {
                    label: "个",
                    key: "pointUtil",
                },
                {
                    label: "已验收合格数量",
                    key: "num",
                    onlyLabel: true,
                },
                {
                    label: "个",
                    key: "numUtil",
                },
            ],
            // 音频开始播放
            bAudioStart: false,
            // 验收内容弹窗显示
            bInspectVisible: false,
            // 锚点前缀
            sAnchorBefore: "S_t_k",
            // 上一个
            lastOffsetTop: 0,
        };
    },
    computed: {
        ...mapState({
            // 验收点弹窗渲染列表
            arrInspectPopupList: (state) => state.projectDetailConstruction.arrInspectPopupList,
            // 类目数组
            arrCategoryList: (state) => state.projectDetailConstruction.arrCategoryList,
            // 展开索引
            arrOpenCategoryKey: (state) => state.projectDetailConstruction.arrOpenCategoryKey,
        }),
    },
    methods: {
        /**
         * 展开内容
         * @param event
         * @param key
         * @param isOpen
         */
        handleOpen(event, key, isOpen) {
            // 保存点击位置
            isOpen && (this.lastOffsetTop = event?.target.offsetTop);
            this.$store.commit({type: "projectDetailConstruction/CHANGE_CATEGORY_OPEN_KEY", key});
            // console.log(this.$store.state.construction.arrCategoryList)
            // 跳回
            this.$nextTick(() => {
                this.$store.state.projectDetailConstruction.objIndexPageRef.scrollTop &&= this.lastOffsetTop ? this.lastOffsetTop - 200 : 0;
            });
        },
        /**
         * 标签选择改变
         * @param { categoryKey:string, labelId:string, activeTagKey:string } option
         */
        switchChange(option) {
            this.$store.commit({
                type: "projectDetailConstruction/CHANGE_CATEGORY_LABEL_STATE",
                ...option,
            });
        },
        /**
         * 设置当前的验收弹窗内容
         * @param list
         */
        setArrInspectList(list) {
            this.$store.commit({type: 'projectDetailConstruction/CHANGE_ARR_INSPECT', list})
            this.handleChangeVisible();
        },
        /**
         * 改变弹窗显示
         */
        handleChangeVisible() {
            this.bInspectVisible = !this.bInspectVisible;
        },
        /**
         * 图片预览
         */
        handleImagePreview(img,key) {
            let arrImage = []
            img.forEach((item,index) => {
                if (index == key) {
                    arrImage.unshift(item.img)
                } else {
                    arrImage.push(item.img)
                }
            })
            ImagePreview(arrImage);
        },
        /**
         * 获取激活的标签键
         */
        activeTagKey(siteLabel) {
            return siteLabel.switchTag?.find((i) => i.active)?.key ?? "default";
        },
    },
};
</script>

<style scoped lang="scss">
@import "construction";
</style>
